<script setup lang="ts">
import { computed } from 'vue'
import { Icon } from '@iconify/vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
}

const props = defineProps<Props>()

</script>

<template>
<div class="table-cell contract-actor-cell">
  <div class="flex flex-row gap-2">
    <div class="icon text-gray-400">Khách:</div>
    <div class="info flex flex-col ">
      <div class="font-[500]">{{props.data?.user?.full_name || '--'}}</div>
<!--      <div class="text-[10px]">#389892 - 098390903</div>-->
    </div>
  </div>
  <div class="flex flex-row gap-2">
    <div class="icon text-gray-400">Môi giới:</div>
    <div class="info flex flex-col ">
      <div class="font-[500]">{{props.data?.broker?.full_name || '--'}}</div>
<!--      <div class="text-[10px]">#389892 - 098390903</div>-->
    </div>
  </div>
</div>
</template>

<style lang="scss">
.contract-actor-cell{
  display: flex;
  flex-direction: column;

  word-break: keep-all;
  white-space: nowrap;
  font-size: 11px;
}
</style>
